import api from './api';

export const trialUpdateService = {
  // Get all trials for update view
  async getAllTrials() {
    try {
      const response = await api.get('/trials');
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Failed to fetch trials');
    }
  },

  // Get trial by ID with full details
  async getTrialById(trialId) {
    try {
      const response = await api.get(`/trials/${trialId}`);
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Failed to fetch trial details');
    }
  },

  // Get trial assignments for a specific trial
  async getTrialAssignments(trialId) {
    try {
      const response = await api.get(`/trials/${trialId}/assignments`);
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Failed to fetch trial assignments');
    }
  },

  // Update trial assignment
  async updateTrialAssignment(assignmentId, assignmentData) {
    try {
      const response = await api.put(`/trial-assignments/${assignmentId}`, assignmentData);
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Failed to update trial assignment');
    }
  },

  // Assign officer to trial location
  async assignOfficerToLocation(trialId, locationId, officerData) {
    try {
      const response = await api.post(`/trials/${trialId}/locations/${locationId}/assign`, officerData);
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Failed to assign officer');
    }
  },

  // Get available plot officers
  async getAvailablePlotOfficers() {
    try {
      const response = await api.get('/officers?role=plot-officer&status=active');
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Failed to fetch plot officers');
    }
  },

  // Update trial status
  async updateTrialStatus(trialId, status) {
    try {
      const response = await api.put(`/trials/${trialId}/status`, { status });
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Failed to update trial status');
    }
  },

  // Get trial progress report
  async getTrialProgress(trialId) {
    try {
      const response = await api.get(`/trials/${trialId}/progress`);
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Failed to fetch trial progress');
    }
  },

  // Export trial data
  async exportTrialData(trialId, format = 'excel') {
    try {
      const response = await api.get(`/trials/${trialId}/export?format=${format}`, {
        responseType: 'blob'
      });
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Failed to export trial data');
    }
  }
};
